import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'firebase/auth';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
})
export class LoginFormComponent implements OnInit {
  authForm!: FormGroup;
  showPassword = true;
  user: User | null = null;
  constructor(
    private formBuilder: FormBuilder,
    private readonly userAuthService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrMsgService: ToastrService
  ) {}

  ngOnInit() {
    this.initForm();
    this.checkLogIn();
  }
  loginWithGoogle() {
    this.userAuthService.loginWithGoogle().then(result => {
      this.user = result.user;
    }).catch(console.error);
  }

  loginWithFacebook() {
    this.userAuthService.loginWithFacebook().then(result => {
      this.user = result.user;
    }).catch(console.error);
  }

  logout() {
    this.userAuthService.logoutA().then(() => {
      this.user = null;
    });
  }

  initForm() {
    this.authForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      acceptTerms: [true]
    });
  }

  checkLogIn() {
    if (this.userAuthService.getUserDetailsFromSession()) {
      const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
      this.router.navigateByUrl(returnUrl || 'home/dashboard');
    }
  }


  get formControls() {
    return this.authForm?.controls;
  }

  signIn() {
    if (this.authForm.invalid) {
      this.authForm.markAllAsTouched();
      return;
    }

    console.log("err", this.authForm.value);
    this.userAuthService.userLogin(this.authForm.value).subscribe({
      next: (res) => {

        console.log(res);
        localStorage.setItem('user', JSON.stringify(res));
        const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
        if (res?.user?.onboardingRequired) {
          // Invited org admins must complete onboarding on first login
          this.router.navigateByUrl(returnUrl || '/onboarding/company-onboarding');
          return;
        }
        const roleNm = res?.user?.role_name;
        if (typeof roleNm === 'string' && roleNm.toLowerCase() === 'vendor') {
          this.router.navigateByUrl(returnUrl || '/home/vendor/resources');
          return;
        }
        if (res?.user.role_id == '1') {
          console.log("admin active");
          this.router.navigateByUrl(returnUrl || 'home/dashboard');
        } else if (res?.user?.status == 'No Membership') {
          console.log("inactive");
          this.router.navigate(['subscription']);
        } else {
          console.log("active");
          this.router.navigateByUrl(returnUrl || 'home/dashboard');
        }
      },
      error: (err) => {
        console.log(err.error.message);
        this.toastrMsgService.error(err.error.message);
        this.authForm.setErrors({ incorrectCredentials: true }); // Set custom error for incorrect credentials
      },
      complete: () => console.log('Observable complete'),
    });
  }

  goToSignup(): void {
    this.router.navigate(['/onboarding']);
  }
  
}
